export default {
  "menu.welcome": "Welcome",
  "menu.more-blocks": "More Blocks",
  "menu.home": "หน้าหลัก",
  "menu.admin": "ผู้ดูแลระบบ",
  "menu.admin.sub-page": "หน้าย่อย",
  "menu.login": "เข้าสู่ระบบ",
  "menu.register": "ลงทะเบียน",
  "menu.register-result": "ผลการลงทะเบียน",
  "menu.xudo": "X CENTER",
  "menu.xudo.xhub": "ฮับ (Gateway)",
  "menu.xudo.xvendor": "ผู้ให้บริการ",
  "menu.xudo.game": "เกม",
  "menu.xudo.players": "ผู้เล่น",
  "menu.xudo.transactions": "ประวัติการเล่น",
  "menu.xudo.control-center": "ศูนย์ควบคุม",
  "menu.xudo.social-platform-automation": "Social Platform Automation",
  "menu.org": "Dashboard",
  "menu.org.home": "แดชบอร์ด",
  "menu.xudo.member": "โอเปอเรเตอร์",
  "menu.xudo.interface-events": "Interface Events",
  'menu.org.gsessions': 'เซสชันเกมผู้เล่น',
  "menu.org.vendor": "ผู้ให้บริการ",
  "menu.org.game": "เกม",
  "menu.org.analysis": "วิเคราะห์",
  "menu.org.ggrtiers": "ตั้งค่า GGR Tier",
  "menu.org.ggrtiers-detail": "รายละเอียด GGR",
  "menu.management": "การจัดการ",
  "menu.management.site-list": "ไซต์ (Lobby)",
  "menu.management.players": "ผู้เล่น",
  "menu.management.players.detail": "รายละเอียดผู้เล่น",
  "menu.management.vendor": "ผู้ให้บริการ",
  "menu.management.game": "เกม",
  "menu.management.game.category": "หมวดหมู่เกม",
  "menu.management.game.all": "ทั้งหมด",
  "menu.management.game.electronic": "อิเล็กทรอนิกส์",
  "menu.management.game.slot": "สล็อต",
  "menu.management.game.table": "เกมโต๊ะ",
  "menu.management.game.live": "คาสิโนสด",
  "menu.management.game.card": "ไพ่",
  "menu.management.game.poker": "โป๊กเกอร์",
  "menu.management.game.arcade": "อาร์เคด",
  "menu.management.game.animal": "ชนสัตว์",
  "menu.management.game.lottery": "หวย",
  "menu.management.game.fish": "เกมปลา",
  "menu.management.game.sport": "กีฬา",
  "menu.management.game.esport": "อีสปอร์ต",
  "menu.org.brand": "แบรนด์",
  'menu.management.player-finance-operations': 'ธุรกรรมที่กำลังดำเนินการ',
  'menu.management.contents': 'คอนเทนต์',
  "menu.settings.fund": "กระเป๋า",
  "menu.settings.finance": "การเงิน",
  "menu.management.provision": "จัดเตรียมไซต์",
  "menu.management.provision-status": "สถานะการจัดเตรียม",
  "menu.management.social-links": "ลิงก์โซเชียล",
  "menu.management.payment-methods": "การเงิน",
  "menu.management.payment": "การเงิน",
  "menu.management.payment.config": "สภาพแวดล้อมและการตั้งค่า",
  "menu.management.payment.bank-accounts": "บัญชีธนาคาร",
  "menu.management.merchant-accounts": "จัดการบัญชีธนาคารร้านค้า",
  "menu.management.finance": "การเงิน",
  "menu.dashboard": "แดชบอร์ด",
  "menu.dashboard.home": "หน้าหลัก",
  "menu.dashboard.analysis": "วิเคราะห์",
  "menu.dashboard.monitor": "ติดตาม",
  "menu.dashboard.gsessions": "เซสชันเกม",
  "menu.dashboard.vendor": "ค่ายเกม",
  "menu.dashboard.game": "เกม",
  "menu.dashboard.workplace": "พื้นที่ทำงาน",
  "menu.dashboard.control-center": "ศูนย์ควบคุม",
  "menu.list.table-list": "ตารางค้นหา",
  "menu.list.basic-list": "รายการพื้นฐาน",
  "menu.list.card-list": "รายการการ์ด",
  "menu.list.search-list": "รายการค้นหา",
  "menu.list.search-list.articles": "รายการค้นหา (บทความ)",
  "menu.list.search-list.projects": "รายการค้นหา (โปรเจกต์)",
  "menu.list.search-list.applications": "รายการค้นหา (แอปพลิเคชัน)",
  "menu.profile": "โปรไฟล์",
  "menu.profile.basic": "โปรไฟล์พื้นฐาน",
  "menu.profile.advanced": "โปรไฟล์ขั้นสูง",
  "menu.result": "ผลลัพธ์",
  "menu.result.success": "สำเร็จ",
  "menu.result.fail": "ล้มเหลว",
  "menu.exception": "ข้อผิดพลาด",
  "menu.exception.not-permission": "403",
  "menu.exception.not-find": "404",
  "menu.exception.server-error": "500",
  "menu.exception.trigger": "ตัวกระตุ้น",
  "menu.settings": "บัญชีและการตั้งค่า",
  "menu.settings.api-config": "ตั้งค่า API",
  "menu.settings.social-links": "ลิงก์โซเชียล",
  "menu.settings.payment-methods": "การเงิน",
  "menu.settings.typography": "ตัวอักษร",
  "menu.account": "บัญชี",
  "menu.account.center": "ศูนย์บัญชี",
  "menu.account.settings": "ตั้งค่าบัญชี",
  "menu.account.trigger": "จำลองข้อผิดพลาด",
  "menu.account.logout": "ออกจากระบบ",
  "menu.settings.account": "บัญชี",
  "menu.editor": "โปรแกรมแก้ไขกราฟิก",
  "menu.editor.flow": "โปรแกรมแก้ไข Flow",
  "menu.editor.mind": "โปรแกรมแก้ไข Mind",
  "menu.editor.koni": "โปรแกรมแก้ไข Koni",
  "micro.loading": "กำลังโหลด Micro App...",
  "micro.error.title": "โหลด Micro App ไม่สำเร็จ",
  "micro.error.description": "กรุณาตรวจสอบว่าเปิดใช้งาน qiankun plugin ใน config/config.ts",
  "micro.notReady": "Micro Frontend ยังไม่พร้อมใช้งาน",
  "provision.title": "จัดเตรียมไซต์ใหม่",
  "provision.step.selectTemplate": "เลือกเทมเพลต",
  "provision.step.configure": "ตั้งค่าไซต์",
  "provision.step.provision": "จัดเตรียม",
  "provision.template.title": "เลือกเทมเพลต",
  "provision.template.selectRequired": "กรุณาเลือกเทมเพลต",
  "provision.template.selected": "เลือกแล้ว",
  "provision.template.estimatedTime": "เวลาโดยประมาณ",
  "provision.config.title": "ตั้งค่าไซต์",
  "provision.config.siteName": "ชื่อไซต์",
  "provision.config.siteName.placeholder": "my-awesome-site",
  "provision.config.siteName.required": "กรุณากรอกชื่อไซต์",
  "provision.config.siteName.pattern": "ใช้ได้เฉพาะตัวพิมพ์เล็ก ตัวเลข และขีดกลาง",
  "provision.config.siteName.min": "ขั้นต่ำ 3 ตัวอักษร",
  "provision.config.environment": "สภาพแวดล้อม",
  "provision.config.environment.sandbox": "Sandbox (ทดสอบ)",
  "provision.config.environment.uat": "UAT (Staging)",
  "provision.config.environment.production": "Production (ใช้งานจริง)",
  "provision.config.currency": "สกุลเงินเริ่มต้น",
  "provision.config.theme": "ธีม",
  "provision.config.theme.default": "ค่าเริ่มต้น",
  "provision.config.theme.dark": "โหมดมืด",
  "provision.config.theme.light": "โหมดสว่าง",
  "provision.ready.title": "พร้อมจัดเตรียม",
  "provision.ready.description": "ไซต์ของคุณจะถูกสร้างด้วยการตั้งค่าต่อไปนี้:",
  "provision.info.title": "ข้อมูล",
  "provision.info.template": "เทมเพลต: โครงสร้างฐานข้อมูลที่ตั้งค่าไว้ล่วงหน้า",
  "provision.info.environment": "สภาพแวดล้อม: สภาพแวดล้อมการใช้งานที่แยกออกจากกัน",
  "provision.info.provisioning": "การจัดเตรียม: การตั้งค่าอัตโนมัติด้วย Neon",
  "provision.btn.previous": "ย้อนกลับ",
  "provision.btn.next": "ถัดไป",
  "provision.btn.provision": "จัดเตรียมไซต์",
  "provision.success.title": "จัดเตรียมไซต์สำเร็จ!",
  "provision.success.description": "ไซต์ {siteName} ของคุณพร้อมใช้งานแล้ว!",
  "provision.success.connection.title": "รายละเอียดการเชื่อมต่อ",
  "provision.success.connection.host": "โฮสต์ฐานข้อมูล",
  "provision.success.connection.dbName": "ชื่อฐานข้อมูล",
  "provision.success.connection.uri": "URI การเชื่อมต่อ",
  "provision.success.connection.copy": "คลิกเพื่อคัดลอก URI ทั้งหมด",
  "provision.success.btn.management": "ไปที่การจัดการไซต์",
  "provision.status.started": "เริ่มการจัดเตรียมแล้ว!",
  "provision.status.failed": "จัดเตรียมไซต์ไม่สำเร็จ",
  "provision.status.success": "จัดเตรียมไซต์สำเร็จ!",
  "fund.title": "บันทึกและการเบิลการใช้งาน",
  "fund.tab.purchase": "ซื้อบันทึก",
  "fund.tab.history": "ประวัติธุรกรรม",
  "fund.tab.vault": "บัญชี",
  "fund.funding.title": "รายการ",
  "fund.balance.title": "ยอดคงเหลือ",
  "fund.balance.pending": "รอดำเนินการ",
  "fund.balance.totalDeposited": "ยอดฝากทั้งหมด",
  "fund.balance.totalSpent": "ยอดใช้จ่ายทั้งหมด",
  "fund.howItWorks.title": "วิธีการใช้งาน",
  "fund.howItWorks.step1": "เลือกแพ็กเกจบันทึก",
  "fund.howItWorks.step2": "กรอกชื่อไซต์ของคุณ",
  "fund.howItWorks.step3": "ชำระเงินด้วยคริปโต (USDT, BTC, ETH)",
  "fund.howItWorks.step4": "ระบบจะจัดเตรียมไซต์ให้อัตโนมัติ",
  "fund.package.title": "เลือกแพ็กเกจบันทึก",
  "fund.siteConfig.title": "ตั้งค่าไซต์",
  "fund.siteConfig.name": "ชื่อไซต์",
  "fund.siteConfig.name.placeholder": "my-awesome-site",
  "fund.siteConfig.name.hint": "นี่จะเป็นตัวระบุที่ไม่ซ้ำกันสำหรับไซต์ของคุณ",
  "fund.siteConfig.package": "แพ็กเกจ",
  "fund.siteConfig.fund": "บันทึก",
  "fund.siteConfig.price": "ราคา",
  "fund.siteConfig.discount": "ส่วนลด",
  "fund.purchase.btn": "ซื้อในราคา {price}",
  "fund.table.date": "วันที่",
  "fund.table.type": "ประเภท",
  "fund.table.fund": "บันทึก",
  "fund.table.amount": "จำนวน",
  "fund.table.status": "สถานะ",
  "fund.table.site": "ไซต์",
  "fund.warning.selectPackage": "กรุณาเลือกแพ็กเกจบันทึก",
  "fund.warning.enterSiteName": "กรุณากรอกชื่อไซต์",
  "menu.settings.paymentMethods": "การเงิน",
  "pages.settings.paymentMethods.title": "การเงิน",
  "pages.settings.paymentMethods.description": "ตั้งค่าการเงินที่สามารถใช้สำหรับการฝากและถอนเงิน",
  "pages.settings.paymentMethods.saveSuccess": "บันทึกการเงินสำเร็จ",
  "pages.settings.paymentMethods.saveError": "บันทึกการเงินไม่สำเร็จ",
  "pages.settings.paymentMethods.enabled": "เปิดใช้งาน",
  "pages.settings.paymentMethods.disabled": "ปิดใช้งาน",
  "pages.settings.paymentMethods.minAmount": "จำนวนเงินขั้นต่ำ",
  "pages.settings.paymentMethods.maxAmount": "จำนวนเงินขั้นสูง",
  "pages.settings.paymentMethods.depositFee": "ค่าธรรมเนียมการฝาก (%)",
  "pages.settings.paymentMethods.withdrawalFee": "ค่าธรรมเนียมการถอน (%)",
  "pages.settings.paymentMethods.apiKey": "API Key",
  "pages.settings.paymentMethods.merchantId": "รหัสผู้ค้า",
  "pages.settings.paymentMethods.save": "บันทึกการเปลี่ยนแปลง",
  "pages.settings.paymentMethods.reset": "รีเซ็ต",
  "pages.settings.paymentMethods.creditDebit": "บัตรเครดิต/เดบิต",
  "pages.settings.paymentMethods.ewallets": "อีเวลเล็ต",
  "pages.settings.paymentMethods.bankTransfer": "การโอนเงินผ่านธนาคาร",
  "pages.settings.paymentMethods.cryptocurrency": "คริปโตเคอร์เรนซี",
  "pages.settings.paymentMethods.mobilePayment": "การเงินผ่านมือถือ",
  "pages.settings.paymentMethods.regional": "การเงินในพื้นที่",
  "pages.settings.paymentMethods.localTransfer": "การโอนเงินในประเทศ",
  "pages.settings.paymentMethods.ewallet": "อีเวลเล็ต",
  "pages.settings.paymentMethods.card": "การเงินด้วยบัตร",
  "menu.org.ggr-tier-config": "NEED_TRANSLATION",
  "menu.exception.403": "NEED_TRANSLATION",
  "menu.exception.404": "NEED_TRANSLATION",
  "menu.exception.500": "NEED_TRANSLATION",
  "menu.form": "NEED_TRANSLATION",
  "menu.form.basic-form": "NEED_TRANSLATION",
  "menu.form.step-form": "NEED_TRANSLATION",
  "menu.form.step-form.info": "NEED_TRANSLATION",
  "menu.form.step-form.confirm": "NEED_TRANSLATION",
  "menu.form.step-form.result": "NEED_TRANSLATION",
  "menu.form.advanced-form": "NEED_TRANSLATION",
  "menu.list": "NEED_TRANSLATION",
  "menu.settings.socialLinks": "NEED_TRANSLATION",
  "pages.settings.socialLinks.saveSuccess": "NEED_TRANSLATION",
  "pages.settings.socialLinks.saveError": "NEED_TRANSLATION",
  "pages.settings.socialLinks.title": "NEED_TRANSLATION",
  "pages.settings.socialLinks.description": "NEED_TRANSLATION",
  "pages.settings.socialLinks.website": "NEED_TRANSLATION",
  "pages.settings.socialLinks.facebook": "NEED_TRANSLATION",
  "pages.settings.socialLinks.twitter": "NEED_TRANSLATION",
  "pages.settings.socialLinks.instagram": "NEED_TRANSLATION",
  "pages.settings.socialLinks.youtube": "NEED_TRANSLATION",
  "pages.settings.socialLinks.linkedin": "NEED_TRANSLATION",
  "pages.settings.socialLinks.github": "NEED_TRANSLATION",
  "pages.settings.socialLinks.discord": "NEED_TRANSLATION",
  "pages.settings.socialLinks.telegram": "NEED_TRANSLATION",
  "fund.fund.amount": "NEED_TRANSLATION",
  "fund.fund.button": "NEED_TRANSLATION",
  "fund.fund.minAmount": "NEED_TRANSLATION",
  "fund..title": "NEED_TRANSLATION",
  "fund.topup.usdtOnly": "NEED_TRANSLATION",
  "fund.tab.domains": "NEED_TRANSLATION",
  "menu.virtual-world": "โลกเสมือน",
  "menu.virtual-world.items": "ไอเทมกดใช้",
  "menu.virtual-world.gifts": "ของขวัญ",
  "menu.virtual-world.promotions": "โปรโมชั่น",
  "menu.reports": "รายงาน",
  "menu.reports.finance": "รายงานการเงิน",
  "menu.reports.members": "รายงานสมาชิก",
  "menu.reports.games": "รายงานเกม",
  "menu.reports.bonus": "รายงานโบนัส"
};
